var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content-wrapper", attrs: { id: "app" } }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "main_mess" }, [
      _c("ul", [
        _c("li", { staticClass: "mess_li" }, [
          _c("span", { staticClass: "fileing" }, [_vm._v("身份证号码：")]),
          _vm._v(" "),
          _c("div", { staticClass: "filediv" }, [_vm._v(_vm._s(_vm.idCard))])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "mess_li" }, [
          _c("span", { staticClass: "fileing" }, [_vm._v("姓名：")]),
          _vm._v(" "),
          _c("div", { staticClass: "filediv" }, [_vm._v(_vm._s(_vm.childName))])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "mess_li" }, [
          _c("span", { staticClass: "fileing" }, [_vm._v("性别：")]),
          _vm._v(" "),
          _c("div", { staticClass: "filediv" }, [_vm._v(_vm._s(_vm.sex))])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "mess_li" }, [
          _c("span", { staticClass: "fileing" }, [_vm._v("生日：")]),
          _vm._v(" "),
          _c("div", { staticClass: "filediv" }, [_vm._v(_vm._s(_vm.birthday))])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "mess_li" }, [
          _c("span", { staticClass: "fileing" }, [_vm._v("所属幼儿园：")]),
          _vm._v(" "),
          _c("div", { staticClass: "filediv" }, [_vm._v(_vm._s(_vm.fullName))])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "mess_li" }, [
          _c("span", { staticClass: "fileing" }, [_vm._v("联系人：")]),
          _vm._v(" "),
          _c("div", { staticClass: "filediv" }, [_vm._v(_vm._s(_vm.relation))])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "mess_li" }, [
          _c("span", { staticClass: "fileing" }, [_vm._v("手机号码：")]),
          _vm._v(" "),
          _c("div", { staticClass: "filediv" }, [
            _vm._v(_vm._s(_vm.relationPhone))
          ])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "mess_li" }, [
          _c("span", { staticClass: "fileing" }, [_vm._v("地址：")]),
          _vm._v(" "),
          _c("div", { staticClass: "filediv" }, [_vm._v(_vm._s(_vm.fullAdd))])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ibox-title" }, [
      _c("h5", [_vm._v("详情")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33d39f8f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33d39f8f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/childmgr/childsmgrDetail.vue
// module id = null
// module chunks = 